import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { GetExtraWorkAgreementQueryResponse, GetProjectResponse } from "api/generatedApi";
import { formatDate, formatHoursAndMinutes, formatNumberToPrice, formatTimestampToDate } from "utils/formats";
import { useExtraWorkAgreementFormatter } from "../hooks/format";
import { approvalStatusMap } from "../edit/inputs/agreement-status";
import { useTranslation } from "react-i18next";
import { SxProps } from "@mui/material";
import { Theme } from "@mui/system";
import { useNavigate } from "react-router-dom";

interface Props {
  project: GetProjectResponse;
  row: GetExtraWorkAgreementQueryResponse;
}

export const DesktopExtraWorkAgreementRow = (props: Props) => {
  const { project, row } = props;
  const { getTypeByAgreementFormatted } = useExtraWorkAgreementFormatter();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const statusTranslation = approvalStatusMap.get(row?.approvalStatus ?? "");

  const sxProps: SxProps<Theme> = {
    cursor: "pointer",
  };
  if (row.approvalStatus === "Cancelled") {
    sxProps.opacity = 0.6;
  }
  return (
    <TableRow
      data-testid={`dashboard-extra-work-agreement-row-${row.name}`}
      onClick={() => {
        navigate(`/projects/${project.id}/dashboard/extraworkagreements/${row.extraWorkAgreementId}`);
      }}
      sx={sxProps}
    >
      <TableCell align="left" sx={{ pr: 5 }} data-testid="dashboard-extra-work-agreement-row-internalid">
        {row.extraWorkAgreementInternalNumber}
      </TableCell>
      <TableCell data-testid="dashboard-extra-work-agreement-row-name">{row.name}</TableCell>
      <TableCell data-testid="dashboard-extra-work-agreement-row-type">{getTypeByAgreementFormatted(row)}</TableCell>
      <TableCell align="right" sx={{ pr: 5 }} data-testid="dashboard-extra-work-agreement-row-hours">
        {formatHoursAndMinutes(row.workTime?.hours, row.workTime?.minutes)}
      </TableCell>
      <TableCell align="right" sx={{ pr: 5 }} data-testid="dashboard-extra-work-agreement-row-payment">
        {formatNumberToPrice(row.paymentDkr)}
      </TableCell>
      <TableCell data-testid="dashboard-extra-work-agreement-row-status">{statusTranslation && t(statusTranslation)}</TableCell>
      <TableCell align="left" sx={{ pr: 5 }} data-testid="dashboard-extra-work-agreement-row-creationdate">
        {formatDate(formatTimestampToDate(props.row.createDateTime))}
      </TableCell>
    </TableRow>
  );
};
